import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import Login from "./containers/Auth"
import Information from './containers/Information';
import ComingSoon from './containers/ComingSoon';
import { isLoggedIn } from './utils';
import Tickets from './containers/Tickets';
import MainContainer from "./containers/Main"
import NewReleases from './containers/Releases';
import NewVideoReleases from './containers/VideoReleases';
import VideoReleasesHistory from './containers/VideoReleases/VideoReleasesHistory';
import ViewVideoReleases from './containers/VideoReleases/ViewVideoReleases';
import ReportsRequests from './containers/Reports';
import UserDetails from './containers/UserDetails.js';
import ViewReleases from './containers/Releases/ViewReleases';
import ViewUserDetails from './containers/UserDetails.js/ViewUserDetails';
import ViewTickets from './containers/Tickets/ViewTickets';
import Artists from './containers/Artists';
import ApprovedRelease from './containers/Releases/ApprovedRelease';
import RejectedRelease from './containers/Releases/RejectedRelease';
import Invite from './containers/Invite';
import Payout from './containers/Payout';
import TakendownRelease from './containers/Releases/TakedownRelease';
import Notification from './containers/Notification';
import UGC from './containers/UgcClaims';
import Linking from './containers/ProfileLinking';
import Pitching from './containers/PlaylistPitching';
import Lyrics from './containers/Lyrics';
import Whitelisting from './containers/WhiteListing/index.js';
import Promotions from './containers/Promotions/index.js';
import UserActions from './containers/UserActions/index.js';

const PrivateRoute = ({ children }) => {
  return isLoggedIn() ? (
    <MainContainer>
      {children}
    </MainContainer>
  ) : (
    <Navigate to='/login' replace />
  );
};

const PublicRoute = ({ children }) => {
  return isLoggedIn() ? <Navigate to="/" replace /> : children;
};

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/static" element={<Navigate to="/login" replace />} />
        <Route path='/login' element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/information" element={<PrivateRoute><Information /></PrivateRoute>} />
        <Route path="/" element={<PrivateRoute><ComingSoon /></PrivateRoute>} />
        <Route path="/tickets" element={<PrivateRoute><Tickets /></PrivateRoute>} />
        <Route path="/invite" element={<PrivateRoute><Invite /></PrivateRoute>} />
        <Route path="/payout" element={<PrivateRoute><Payout /></PrivateRoute>} />
        <Route path="/view_tickets/:id" element={<PrivateRoute><ViewTickets /></PrivateRoute>} />
        <Route path="/user_details" element={<PrivateRoute><UserDetails /></PrivateRoute>} />
        <Route path="/user_actions" element={<PrivateRoute><UserActions /></PrivateRoute>} />
        <Route path="/releases/review" element={<PrivateRoute><NewReleases /></PrivateRoute>} />
        <Route path="/release/approved" element={<PrivateRoute><ApprovedRelease /></PrivateRoute>} />
        <Route path="/release/rejected" element={<PrivateRoute><RejectedRelease /></PrivateRoute>} />
        <Route path="/release/takendown" element={<PrivateRoute><TakendownRelease /></PrivateRoute>} />
        <Route path="/artists" element={<PrivateRoute><Artists /></PrivateRoute>} />
        <Route path="/report_requests" element={<PrivateRoute><ReportsRequests /></PrivateRoute>} />
        <Route path="/notifications" element={<PrivateRoute><Notification /></PrivateRoute>} />
        <Route path="/view_releases/:id" element={<PrivateRoute><ViewReleases /></PrivateRoute>} />
        <Route path="/view_user_details/:id" element={<PrivateRoute><ViewUserDetails /></PrivateRoute>} />
        <Route path="/ugc_claims" element={<PrivateRoute><UGC /></PrivateRoute>} />
        <Route path="/profile_linking" element={<PrivateRoute><Linking /></PrivateRoute>} />
        <Route path="/playlist_pitching" element={<PrivateRoute><Pitching /></PrivateRoute>} />
        <Route path="/lyrics_distribution" element={<PrivateRoute><Lyrics /></PrivateRoute>} />
        <Route path="/video_releases/review" element={<PrivateRoute><NewVideoReleases /></PrivateRoute>} />
        <Route path="/video_releases/history" element={<PrivateRoute><VideoReleasesHistory /></PrivateRoute>} />
        <Route path="/view_video_release/:id" element={<PrivateRoute><ViewVideoReleases /></PrivateRoute>} />
        <Route path="/whitelisting" element={<PrivateRoute><Whitelisting /></PrivateRoute>} />
        <Route path="/promotions" element={<PrivateRoute><Promotions /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}
